import React from 'react'
import StarIcon from '../../ui/icons/StarIcon'

const BADGE_CLASS = 'tw:inline-flex tw:items-center tw:gap-1 tw:text-xs tw:font-medium '
  + 'tw:bg-green-100 tw:text-green-800 tw:rounded! tw:px-2 tw:py-0.5'

const DefaultBadge = () => (
  <span className={BADGE_CLASS}>
    <StarIcon className="tw:size-3" />
    <span>Par défaut</span>
  </span>
)

export default DefaultBadge
